exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sc-message--system[data-v-bf652198] {\r\n  padding: 8px 20px;\r\n  border-radius: 6px;\r\n  font-weight: 300;\r\n  font-size: 12px;\r\n  line-height: 1.2;\r\n  white-space: pre-wrap;\r\n  -webkit-font-smoothing: subpixel-antialiased;\r\n  font-style: italic;\r\n  opacity: .55;\n}\n.sc-message--meta[data-v-bf652198] {\r\n  font-size: xx-small;\r\n  margin-bottom: 0px;\r\n  margin-top: 5px;\r\n  opacity: .5;\r\n  text-align: center;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bf652198","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/vue-beautiful-chat/src/messages/SystemMessage.vue
// module id = 1940
// module chunks = 116